// Real photos provided by the operator (mapping verified with user)
export const IMG = {
  // Studio photo of the actual white 10-seat minibus
  minibus: "https://customer-assets.emergentagent.com/job_ruta-spiritu-habana/artifacts/oqcukm67_image.png",
  aeropuerto: "https://customer-assets.emergentagent.com/job_ruta-spiritu-habana/artifacts/6m8xv51f_image.webp",
  embajada: "https://customer-assets.emergentagent.com/job_ruta-spiritu-habana/artifacts/ea2kgxpa_image.png",
  parque: "https://customer-assets.emergentagent.com/job_ruta-spiritu-habana/artifacts/v7ootith_image.png",
  lonja: "https://customer-assets.emergentagent.com/job_ruta-spiritu-habana/artifacts/uucqup3p_image.png",
  cabaiguan: "https://customer-assets.emergentagent.com/job_ruta-spiritu-habana/artifacts/2db9qegy_image.webp",
};

// Photos for private-trip destinations (uploaded order: Viñales, Varadero, Matanzas, Cienfuegos, Santa Clara)
// Note: asset URLs returned in reverse-chronological order — corrected mapping below.
export const PRIVATE_IMG = {
  santaClara: "https://customer-assets.emergentagent.com/job_ruta-spiritu-habana/artifacts/zdpsznra_image.png",
  cienfuegos: "https://customer-assets.emergentagent.com/job_ruta-spiritu-habana/artifacts/vv544xof_image.png",
  matanzas: "https://customer-assets.emergentagent.com/job_ruta-spiritu-habana/artifacts/20x3j34a_image.png",
  varadero: "https://customer-assets.emergentagent.com/job_ruta-spiritu-habana/artifacts/67rynlhi_image.webp",
  vinales: "https://customer-assets.emergentagent.com/job_ruta-spiritu-habana/artifacts/iknpqb99_image.webp",
  // to be added by user in next batch:
  cayoSantaMaria: "https://customer-assets.emergentagent.com/job_ruta-spiritu-habana/artifacts/cbrn26bf_image.webp",
  cayoCoco: "https://customer-assets.emergentagent.com/job_ruta-spiritu-habana/artifacts/1qb1igr1_image.png",
  ciegoDeAvila: "https://customer-assets.emergentagent.com/job_ruta-spiritu-habana/artifacts/lyofg5y7_image.webp",
  camaguey: "https://customer-assets.emergentagent.com/job_ruta-spiritu-habana/artifacts/5a65k4g8_image.png",
};
